<template>
  <transition-group name="c-messages-fade" tag="div" class="c-messages">
    <div :class="['c-message', `c-message--${message.options.variant}`, { 'c-message--is-toast': message.isToast }]" :key="message.identifier" v-for="message in messages">
      <div class="flex justify-start">
        <font-awesome-icon class="c-message__icon" v-if="message.icon" :icon="message.icon" />

        <base-link v-if="message.route" :label="message.title" :to="message.route" :content="$t('label.view')" class="c-message__route-link" @click.native="removeMessage(message.identifier, $event)" type="forward"/>
        <span v-else class="c-message__text">{{message.title}}</span>
      </div>

      <div class="h-6 ml-4">
        <base-timer v-if="message.options.time > 0" :initial-time="message.options.time / 1000"/>

        <base-button v-if="message.options.time === 0 && message.options.isDismissible" variant="link" class="c-message__close" @click="removeMessage(message.identifier, $event)">
          <font-awesome-icon :icon="['fal', 'times']" />
        </base-button>
      </div>
    </div>
  </transition-group>
</template>

<script>
/**
 * How to create a message
 * this.$store.dispatch('showMessage', { title: 'Changes saved successfully' })
 *
 * Create a message that will disappear after x milliseconds
 * this.$store.dispatch('showMessage', { title: 'Hide message after 5 seconds', autoHideDelay: 5000 })
 *
 * Create a message with an icon
 * this.$store.dispatch('showMessage', { title: 'This message has an icon', icon: ['fal', 'exclamation-triangle'] })
 *
 * Create a message with a link 'view' more
 * this.$store.dispatch('showMessage', { title: 'This message has a link', route: { name: 'reportingOverview' } })
 *
 * Default options:
 * - variant: 'primary'
 * - isDismissible: true
 *
 * You can add / change additional options to an message
 * this.$store.dispatch('showMessage', { title: 'Changes unsuccessfully saved, please try again', options: { variant: 'danger' } })
 * this.$store.dispatch('showMessage', { title: 'Neutral info message', options: { variant: 'info', isDismissible: false } })
 * this.$store.dispatch('showMessage', { title: 'this message will destroy himself in 5 seconds', autoHideDelay: 5000, options: { variant: 'info', isDismissible: false } })
 * this.$store.dispatch('showMessage', { title: 'This message has an icon', icon: ['fas', 'exclamation-triangle'], options: { isDismissible: false }  })
 *
 * How to create a toast message, a toast message isn't full width, note, showToast instead of showMessage
 * this.$store.dispatch('showToastMessage', { title: 'This is a toast message' })
 *
 * Default options: (extend default options from message)
 * - autoHideDelay: 5000
 *
 * this.$store.dispatch('showToastMessage', { title: 'This is a toast message' })
 * this.$store.dispatch('showToastMessage', { title: 'This toast message will disable the auto hide', autoHideDelay: 0, options: { variant: 'warning', isDismissible: false } })
 * this.$store.dispatch('showToastMessage', { title: 'This toast message will change the default auto hide option', autoHideDelay: 10000, options: { variant: 'dark' } })
 * this.$store.dispatch('showToastMessage', { title: 'This toast message has an icon', icon: ['fas', 'exclamation-triangle'], options: { isDismissible: false }  })
 */

import { mapState, mapActions } from 'vuex'

export default {
  name: 'messages',

  computed: {
    ...mapState({
      messages: state => state.messages.slice().sort((a, b) => b.isToast - a.isToast)
    })
  },

  methods: mapActions([
    'removeMessage'
  ])
}
</script>
